import { useQuery } from "react-query";
import api from "../services/api";

export const useExternalLinks = () => {
  return useQuery([`external-links`], () => api.fetchExternalLinks());
};
